var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',{staticStyle:{"font-size":"24px","color":"black"}},[_vm._v("欢迎登录")])])
}]

export { render, staticRenderFns }